module.exports = __webpack_public_path__ + "img/Kyoutai_lalamee.a85b6ee6.png";